module.exports = __webpack_public_path__ + "static/media/03-intro.317641c3.png";